import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { BookingService } from '../../../services/booking/booking.service';
import { Subscription } from 'rxjs/Subscription';

export class BookingReportData {
  from: Date;
  to: Date;
}

@Component({
  selector: 'act-dialog-booking-report',
  templateUrl: './dialog-booking-report.component.html',
  styleUrls: ['./dialog-booking-report.component.scss']
})
export class DialogBookingReportComponent implements OnInit {

  public chechInDateForm: FormGroup;
  public stateDaterangepicker: any;
  public reportExportSubscriber: Subscription;
  public defaultDate = false;
  public isLoading = false;
  public isError = false;
  public intervalSubscription: Subscription;

  constructor(
    @Inject(MD_DIALOG_DATA) public data: BookingReportData,
    private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<DialogBookingReportComponent>,
    private bookingService: BookingService,
  ) {
    this.chechInDateForm = this.formBuilder.group({
      'from': [this.data ? this.data.from : '', Validators.required],
      'to': [this.data ? this.data.to : '', Validators.required],
    });
    this.defaultDate = !!this.data;

    this.chechInDateForm.valueChanges.subscribe(() => {
      this.isError = false;
    });
  }

  ngOnInit() {

  }

  exportReport() {
    if (this.chechInDateForm.value.from && this.chechInDateForm.value.to) {
      this.reportExportSubscriber && this.reportExportSubscriber.unsubscribe();
      this.isLoading = true;
      this.reportExportSubscriber = this.bookingService.getAccuredReport(this.chechInDateForm.value.from, this.chechInDateForm.value.to).subscribe(
        (res) => {
          this.intervalSubscription && this.intervalSubscription.unsubscribe();
          this.intervalSubscription = this.bookingService.downloadReport(res.downloadReportId).subscribe((inter) => {
            inter && this.intervalSubscription.unsubscribe();
            this.closeDialog();
          }, error => {
            this.isLoading = false;
            this.handleError(error);
          });
        }, (error) => {
          this.isLoading = false;
          this.handleError(error);
        });
    } else {
      this.isError = true;
    }

  }

  closeDialog(error?: string, data?: BookingReportData) {
    this.dialogRef.close(error ? { error: error, data: data } : undefined);
  }

  onCancael() {
    this.reportExportSubscriber && this.reportExportSubscriber.unsubscribe();
    this.closeDialog();
  }

  handleError(error) {
    const data = new BookingReportData;
    data.from = this.chechInDateForm.value.from;
    data.to = this.chechInDateForm.value.to;
    let code = '6001';
    try {
      const errors = error.error.json();
      if (errors.errors[0].message === 'Data report not found.') {
        code = '4004';
      }
    } catch (ex) {
      console.log(ex);
    }
    this.closeDialog(code, data);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-booking-report/dialog-booking-report.component.ts